import { MDS_COLORS_LINE_BORDER } from '@rappi/mustache-b2b-foundations';
import styled from 'styled-components';
export const Container = styled.div `
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
`;
export const Main = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  min-height: 500px;
`;
export const VerticalDivider = styled.div `
  width: 1px;
  height: 100%;
  background-color: ${MDS_COLORS_LINE_BORDER};
`;
export const HorizontalDivider = styled.div `
  width: 100%;
  height: 1px;
  background-color: ${MDS_COLORS_LINE_BORDER};
`;
